"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
require("./CCApplicationStatus.css");
var CCApplicationStatus = function (_a) {
    var status = _a.status, reason = _a.reason;
    var boldAfterColon = function (text) {
        var regex = /:(.*)$/;
        return text.replace(regex, function (match, p1) { return ": <strong>".concat(p1.trim(), "</strong>"); });
    };
    var formattedReason = reason ? boldAfterColon(reason) : '';
    switch (status) {
        case 'New':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "New");
        case 'In Progress':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "In Progress");
        case 'Callback Requested':
            return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                react_1.default.createElement("div", { className: "neutralStatusChip" }, "Callback Requested"),
                react_1.default.createElement("div", { className: "neutralStatusContext", dangerouslySetInnerHTML: { __html: formattedReason } })));
        case 'Lost':
            return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                react_1.default.createElement("div", { className: "negativeStatusChip" }, "Lost"),
                react_1.default.createElement("div", { className: "negativeStatusContext", dangerouslySetInnerHTML: { __html: formattedReason } })));
        case 'Unqualified':
            return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                react_1.default.createElement("div", { className: "negativeStatusChip" }, "Unqualified"),
                react_1.default.createElement("div", { className: "negativeStatusContext", dangerouslySetInnerHTML: { __html: formattedReason } })));
        case 'Exhausted':
            return react_1.default.createElement("div", { className: "negativeStatusChip" }, "Exhausted");
        case 'Qualified':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "Qualified");
        case 'Application in Progress':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "Application In Progress");
        case 'Application Started':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "Application Started");
        case 'Awaiting Docs':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "Awaiting Docs");
        case 'Documents Received':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "Documents Received");
        case 'Ready for Submission':
            return react_1.default.createElement("div", { className: "neutralStatusChip" }, "Ready for Submission");
        case 'Submitted to Lender':
            return (react_1.default.createElement("div", { className: "statusContainer" },
                react_1.default.createElement("div", { className: "neutralStatusChip" }, "Submitted to Lender"),
                react_1.default.createElement("div", { className: "neutralStatusContext" },
                    "Lender: ",
                    react_1.default.createElement("strong", null, reason))));
        case 'Application Withdrawn':
            return (react_1.default.createElement("div", { className: "statusContainer" },
                react_1.default.createElement("div", { className: "negativeStatusChip" }, "Application Withdrawn"),
                react_1.default.createElement("div", { className: "negativeStatusContext", dangerouslySetInnerHTML: { __html: formattedReason } })));
        case 'Approved':
            return (react_1.default.createElement("div", { className: "statusContainer" },
                react_1.default.createElement("div", { className: "wonStatusChip" }, "Approved"),
                react_1.default.createElement("div", { className: "neutralStatusContext" },
                    "Lender: ",
                    react_1.default.createElement("strong", null, reason))));
        case 'Declined':
            return react_1.default.createElement("div", { className: "negativeStatusChip" }, "Declined");
        case 'Pending Settlement':
            return (react_1.default.createElement("div", { className: "statusContainer" },
                react_1.default.createElement("div", { className: "neutralStatusChip" }, "Pending Settlement"),
                react_1.default.createElement("div", { className: "neutralStatusContext" },
                    "Lender: ",
                    react_1.default.createElement("strong", null, reason))));
        case 'Won':
            return (react_1.default.createElement("div", { className: "statusContainer" },
                react_1.default.createElement("div", { className: "wonStatusChip" }, "Won"),
                react_1.default.createElement("div", { className: "neutralStatusContext" },
                    "Lender: ",
                    react_1.default.createElement("strong", null, reason))));
        default:
            return null;
    }
};
CCApplicationStatus.propTypes = {
    status: prop_types_1.default.string.isRequired,
    reason: prop_types_1.default.string,
};
exports.default = CCApplicationStatus;
